module.exports = __webpack_public_path__ + "img/2.0c2d2409.png";